/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Tab_ModifyInputs */

const en_cad_features_tab_modify = /** @type {(inputs: Cad_Features_Tab_ModifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modify`)
};

/**
* | output |
* | --- |
* | "Modify" |
*
* @param {Cad_Features_Tab_ModifyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_tab_modify = /** @type {((inputs?: Cad_Features_Tab_ModifyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Tab_ModifyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_tab_modify(inputs)
});
export { cad_features_tab_modify as "cad.features.tab_modify" }